<template>
	<div>
		<h1 class="page-title">{{ title }}</h1>
		<b-row>
			<b-col>
				<b-form class="search-block" @submit.prevent>
					<b-form-group>
						<b-form-input
							type="text"
							:placeholder="placeHolder"
							v-model="stringValue"
							@keyup.enter.prevent="handleOnClick"
						></b-form-input>
					</b-form-group>
					<b-button
						class="position-absolute"
						type="button"
						variant="link"
						@click.prevent="handleOnClick"
						>Buscar</b-button
					>
				</b-form>
			</b-col>
			<b-col class="custom-btn-width">
				<b-button block type="submit" variant="secondary" @click="handleSearchClick">{{
					btnLabel
				}}</b-button>
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			required: true
		},
		placeHolder: {
			type: String,
			default: function () {
				this.$t('lang.content.search');
			}
		},
		btnLabel: {
			type: String,
			required: true
		},
		goTo: {
			type: String,
			required: true
		},
		defaultValue: {
			type: String
		}
	},
	data: () => ({
		stringValue: ''
	}),
	mounted: function () {
		this.stringValue = this.defaultValue;
	},
	methods: {
		handleOnClick() {
			this.$emit('searchEvent', this.stringValue);
		},

		handleSearchClick() {
			this.$router.push(this.goTo);
		}
	}
};
</script>

<style scoped></style>
